import '../../index.css';
import CookieBanner from '../../components/CookieBanner';
import Footer from '../../components/Footer';
import { Header } from '../../components/Header/Header';
import StoreProvider from '../../next-lib/store-provider';
import { CssBaseline } from '@mui/material';
import ThemeNextProvider from '../../next-lib/theme-provider';
import { Locale } from '../../next-lib/components/locale.component';
import LiveHelp from '../../components/LiveHelp';
import { AlumniSansFont, RobotoFont } from '../../styles/fonts';
import SubmitAlert from '../../react-pages/Product/SubmitAlert/SubmitAlert';
import Overlay from '../../components/Overlay';
import { AppInsightsProvider } from 'src/providers/AppInsightsProvider';
import LCPImageView from '../../components/LCPFix/LCPImageView';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v14-appRouter';
import { InitialStoreState } from '../../store/store';
import GoToTopButton from '../../components/GoToTop/GoToTopButton';

export default function NextApp({
  children,
  initialState,
}: {
  children: React.ReactNode;
  lang?: string;
  initialState?: InitialStoreState;
}) {
  return (
    <AppRouterCacheProvider options={{ enableCssLayer: true }}>
      <StoreProvider initialState={initialState}>
        <Locale />
        <LCPImageView />
        <ThemeNextProvider>
          <AppInsightsProvider>
            <div className={`${RobotoFont.variable} ${AlumniSansFont.variable}`}>
              <CssBaseline />
              <Header />
              <main>{children}</main>
              <CookieBanner />
              <Footer />
              <GoToTopButton />
              <LiveHelp />
            </div>
          </AppInsightsProvider>
        </ThemeNextProvider>
        <SubmitAlert />
        <Overlay />
      </StoreProvider>
    </AppRouterCacheProvider>
  );
}
